module.exports = __webpack_public_path__ + "static/media/captain-chip-new.svg.be1e6deb.png";